/**
 * 📄 SorteoPage.jsx
 * Wrapper del módulo admin de sorteo / feria.
 */
import React from "react";
import SorteoList from "../components/Sorteo/SorteoList";

export default function SorteoPage() {
    return <SorteoList />;
}
